module.exports = __webpack_public_path__ + "static/img/14000263.99ccc051.png";